module.exports = __webpack_public_path__ + "img/firstfinancial3.8766ed78.jpg";